import { getRenderStyleProperty } from '../../../../../../CanvasState/Helpers/Style/textBody';
import { getPrioritizedTextBody } from '../../../Utils/textBody';

const getTextBodyMargins = shape => getRenderStyleProperty(shape, getPrioritizedTextBody(shape), ['margins']);

export default getTextBodyMargins;
